import React, {useState, useContext} from 'react';
import { BuildingContext } from '../../contexts/BuildingContext';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        <h3>건물의 모든 정보를 삭제할까요?</h3>
        <div className='delete-message'>
            입력했던 모든 건물 정보가 삭제됩니다.<br />
            정보를 삭제하기 전 다시 한 번 확인해 주세요.
        </div>
        <div className="delete-modal-buttons">
          <button onClick={onClose} className="cancel-button">취소</button>
          <button onClick={onConfirm} className="confirm-button">네 삭제할게요</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
